module.exports = __webpack_public_path__ + "static/img/logo81.e9dba08.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo81.png
// module id = o4+G
// module chunks = 1